
import * as THREE from "three";
import React, { useMemo, useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import { useEffect } from "react/cjs/react.development";
import { PlaneBufferGeometry, SphereGeometry } from "three";


const dummy = new THREE.Object3D();


const rands = [];

function lerp(value1, value2, amount) {
	amount = amount < 0 ? 0 : amount;
	amount = amount > 1 ? 1 : amount;
	return value1 + (value2 - value1) * amount;
};

const Boxes = ({ amount, wireframe }) => {
  
  const { scene, camera, gl } = useThree();

  let material;
  if(wireframe) material = new THREE.MeshLambertMaterial({ color: 'red', wireframe: true });
  else material = new THREE.MeshLambertMaterial({ color: 'red' });
  const prismGeometry = new THREE.BoxGeometry(0.5,0.5,0.5);
  const ref = useRef();

    for (let i = 0; i < amount; i++) {
        rands[i] = Math.random()+0.1;
    }
    gl.autoClearColor = false;


    var fadeMaterial = new THREE.MeshBasicMaterial({
        color: 0x000000,
        transparent: true,
        opacity: 0.1
    });
    var fadePlane = new THREE.PlaneBufferGeometry(100, 100);
    var fadeMesh = new THREE.Mesh(fadePlane, fadeMaterial);

    if(camera.children.length === 0) {
        camera.add(fadeMesh);
        scene.add(camera);
        
    }

    fadeMesh.position.set(0,0,-1);
    // fadeMesh.rotation.set(0, 0, Math.PI / 2)

    // fadeMesh.renderOrder = -1;

    let mesh = new THREE.Mesh(new PlaneBufferGeometry(100,100), new THREE.MeshBasicMaterial({color: '0x200000'}));
    mesh.lookAt(camera.position);
    scene.add(mesh);
    setTimeout(() => scene.remove(mesh), 100);
    
  useFrame(({ clock, mouse }) => {
    let counter = 0;
    const t = clock.oldTime * 0.0005;
    const radius = 1;

    for (let i = 0; i < amount; i++) {

        dummy.position.set(Math.sin(i+t*2 * rands[i]) * Math.cos(i * rands[i]+t), 
                            Math.sin(i * rands[i]+t) * Math.sin(i+t*2 * rands[i]), 
                            Math.cos(i+t*2 * rands[i])).multiplyScalar(lerp(rands[i]*3, 1.0, mouse.distanceTo(new THREE.Vector2(0,0))));
        dummy.scale.set(rands[i]*0.1, rands[i]*0.1, rands[i]*0.1);
        dummy.lookAt(new THREE.Vector3(0, 0, 0));
        dummy.updateMatrix();
        ref.current.setMatrixAt(i, dummy.matrix);
        
    }
    ref.current.instanceMatrix.needsUpdate = true;
  });

  return <instancedMesh ref={ref} args={[prismGeometry, material, amount]} />;
};

export default Boxes;